import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ErrorFallback } from '../components/ErrorFallback/ErrorFallback';
import BidsPage from '../pages/Bids';
import CoInvestmentsPage from '../pages/CoInvestments';
import DashboardPage from '../pages/Dashboard';
import InvestmentsPage from '../pages/Investments';
import JobsPage from '../pages/Jobs';
import LoanPage from '../pages/Loan';
import LoansPage from '../pages/Loans';
import LoansApplyPage from '../pages/LoansApply';
import MessagePage from '../pages/Message';
import ServiceProviderPage from '../pages/ServiceProvider';
import ServiceProvidersPage from '../pages/ServiceProviders';
import SettingsPage from '../pages/Settings';
import TransactionsPage from '../pages/Transactions';

export function PrivateRoutes() {
  console.log('private');
  return (
    <Switch>
      <Route path='/dashboard' component={DashboardPage} exact />
      <Route path='/loans/apply' component={LoansApplyPage} />
      <Route path='/loans/:menu?' component={LoansPage} />
      <Route path='/loan/:id/:tab?' component={LoanPage} />
      <Route path='/investments/:menu?'>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <InvestmentsPage />
        </ErrorBoundary>
      </Route>
      <Route path='/co-investments/:menu?' component={CoInvestmentsPage} />
      <Route path='/service-providers/:id' component={ServiceProviderPage} />
      <Route path='/service-providers' component={ServiceProvidersPage} />
      <Route path='/jobs/:menu?' component={JobsPage} />
      <Route path='/bids/:menu?' component={BidsPage} />
      <Route path='/messages/:group_key?' component={MessagePage} />
      <Route path='/transactions'>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <TransactionsPage />
        </ErrorBoundary>
      </Route>
      <Route path='/settings/:menu?' component={SettingsPage} />
      <Redirect from='/auth' to='/dashboard' />
      <Redirect exact from='/' to='/dashboard' />
      {/* <Redirect to='error/404' /> */}
    </Switch>
  );
}
